import { useState, useEffect } from 'react';

export type DeviceType = 'mobile' | 'tablet' | 'desktop';

export interface ResponsiveVisibility {
  mobile?: boolean;
  tablet?: boolean;
  desktop?: boolean;
}

/** Все три экрана включены по умолчанию */
export const DEFAULT_VISIBILITY: ResponsiveVisibility = {
  mobile: true,
  tablet: true,
  desktop: true,
};

export function useResponsive(): { device: DeviceType; isMobile: boolean; isTablet: boolean; isDesktop: boolean } {
  const [device, setDevice] = useState<DeviceType>('desktop');

  useEffect(() => {
    const check = () => {
      const w = window.innerWidth;
      if (w < 640) setDevice('mobile');
      else if (w < 1024) setDevice('tablet');
      else setDevice('desktop');
    };
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  return {
    device,
    isMobile: device === 'mobile',
    isTablet: device === 'tablet',
    isDesktop: device === 'desktop',
  };
}

/** Проверяет, видим ли элемент на текущем устройстве */
export function isVisible(visibility: ResponsiveVisibility | undefined | null, device: DeviceType): boolean {
  if (!visibility) return true; // нет настроек — показано всегда
  return visibility[device] !== false; // по умолчанию true
}
